import { SHEETS_TIMER_DEFAULTS } from 'constants/dictionaries/sheetsTimer';
import { SupportedSubjects } from 'types/Subject';

const STORAGE_KEY = `${process.env.REACT_APP_VERSION ?? 'v1'}_sheets_timer`;

type PersistedSheetsTimerStore = Record<string, number | null>;

const readStore = (): PersistedSheetsTimerStore => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as PersistedSheetsTimerStore;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeStore = (store: PersistedSheetsTimerStore): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // Ignore quota / private mode errors.
  }
};

export const loadSheetsTimerDuration = (subjectCode: SupportedSubjects): number | null | undefined => {
  const persisted = readStore()[subjectCode];
  if (persisted === undefined) {
    return undefined;
  }

  return persisted;
};

export const saveSheetsTimerDuration = (subjectCode: SupportedSubjects, durationMinutes: number | null): void => {
  const store = readStore();
  store[subjectCode] = durationMinutes;
  writeStore(store);
};

export const resolveSheetsTimerDuration = (subjectCode: SupportedSubjects): number | null => {
  const persisted = loadSheetsTimerDuration(subjectCode);
  if (persisted !== undefined) {
    return persisted;
  }

  return SHEETS_TIMER_DEFAULTS[subjectCode];
};
